import React, { PureComponent } from 'react';

import styles from 'components/ErrorHandler/ErrorHandler.module.css';

interface ErrorHandlerProps {
  errorElement?: React.ReactNode;
  onError?: (error: Error, info: unknown) => void;
  children?: React.ReactNode;
}

interface ErrorHandlerState {
  hasError: boolean;
}

class ErrorHandler extends PureComponent<ErrorHandlerProps, ErrorHandlerState> {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: unknown) {
    this.setState({ hasError: true });
    const { onError = () => {} } = this.props;
    onError(error, info);
  }

  render() {
    const {
      errorElement = (
        <b className={styles.errorMessage}>Oh no, Something went wrong! :( </b>
      ),
    } = this.props;
    if (this.state.hasError) {
      return errorElement;
    }
    try {
      return <>{this.props.children}</>;
    } catch (error) {
      console.warn(error);
      this.setState({ hasError: true });
      return errorElement;
    }
  }
}

export default ErrorHandler;
